import { HelpCircle } from "lucide-react";
import { useLocation } from "react-router-dom";

export const manualUrl = (section) => `/handleiding${section ? `#${section}` : ""}`;

const CLUB_TAB_SECTIONS = {
  historicals: "voorgaande-jaren",
  depreciations: "afschrijvingen",
  "existing-loans": "bestaande-leningen",
  scenarios: "scenarios",
  comparison: "begrotingsvergelijking",
  budget: "begroting",
  branding: "huisstijl",
  team: "team",
};

// Bepaalt op basis van de huidige route (en ?tab=) welk hoofdstuk van de handleiding past.
export function useHelpSection() {
  const { pathname, search } = useLocation();
  if (pathname.startsWith("/handleiding")) return null;
  if (pathname === "/") return "dashboard";
  if (pathname === "/account" || pathname === "/payment-status") return "account";
  if (pathname === "/prijzen") return "abonnementen";
  if (pathname === "/beheer") return "beheer";
  if (pathname === "/uitnodigingen") return "beheer-uitnodigingen";
  const club = pathname.match(/^\/clubs\/[^/]+(\/.*)?$/);
  if (club) {
    const rest = club[1] || "";
    if (rest === "/compare") return "vergelijken";
    if (rest.startsWith("/scenarios/")) return rest === "/scenarios/new" || rest.endsWith("/edit") ? "scenariobouwer" : "scenariorapport";
    const tab = new URLSearchParams(search).get("tab") || "historicals";
    return CLUB_TAB_SECTIONS[tab] || "club";
  }
  return "start";
}

export default function HelpButton({ section, label = "Handleiding", size = "md", className = "" }) {
  const dims = size === "sm" ? "w-7 h-7" : "w-10 h-10";
  const icon = size === "sm" ? "w-4 h-4" : "w-5 h-5";
  return (
    <a
      href={manualUrl(section)}
      target="_blank"
      rel="noopener noreferrer"
      title={`${label} openen in een nieuw venster`}
      aria-label={`${label} openen in een nieuw venster`}
      data-testid={`help-btn-${section || "start"}`}
      data-pdf-ignore="1"
      className={`btn-brutal bg-background text-foreground ${dims} inline-flex items-center justify-center shrink-0 hover:bg-primary hover:text-primary-foreground transition-colors print:hidden ${className}`}
    >
      <HelpCircle className={icon} />
    </a>
  );
}
